import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";

import { api } from "./pureFunctions"
import { Button, Form, Col, Alert } from "react-bootstrap";

export default function AllgemeineBemerkung({ loading, fieldName, data, user, changeData, sendData }) {
   const [show, setShow] = useState(false);
   const [oldData, setOldData] = useState();

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

   useEffect(() => {
      setOldData(data[fieldName]);
   }, []);

   return (
      <>
         {/* {(["globaladmin","admin", "editor"].includes(user.role) || data[fieldName]) && ( */}
            <button
               // disabled={!["globaladmin","admin", "editor"].includes(user.role)}
               className="mt-1 ms-0 eskpause-button w-100"
               onClick={handleShow}
            >
               Warnhinweis
            </button>
         {/* )} */}

         <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
               <Modal.Title>Allgemeine Bemerkung</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form>
                  <Form.Group className="mb-3" key="abc">
                     <Form.Control
                        maxLength={80}
                        as="textarea"
                        placeholder=""
                        onChange={(e) => changeData(e.target.name, e.target.value, "single")}
                        name={fieldName}
                        value={data[fieldName]}
                        style={{ height: "70px" }}
                     />
                     <Form.Text muted>
                        {data[fieldName] ? data[fieldName].length : 0}/{80}
                     </Form.Text>
                  </Form.Group>
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button
                  variant="secondary"
                  onClick={() => {
                     changeData(fieldName, oldData, "single");
                     handleClose();
                  }}
               >
                  Abbrechen
               </Button>
               <Button
                  variant="primary"
                  disabled={loading}
                  onClick={() => {
                     sendData({});
                     handleClose();
                  }}
               >
                  Speichern
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
}
